module.exports = __webpack_public_path__ + "assets/img/2061.e825d95e.png";